import { For } from '../c-mp/comp/For'
import { Icon } from '../c-mp/comp/Icon'
import type { IShowThenProps } from '../c-mp/comp/Show'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { url } from '../c-mp/fun/url'
import { andrisEmail } from '../fun/andrisEmail'
import { expectDefined } from '../fun/expectDefined'
import { formatDate } from '../fun/formatDate'
import { formatNumber } from '../fun/formatNumber'
import { getAge } from '../fun/getAge'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getPersonNameFormatted } from '../fun/getPersonNameFormatted'
import { indent } from '../fun/indent'
import { isDead } from '../fun/isDead'
import { setPageTitle } from '../fun/setPageTitle'
import { ICON_PLUS } from '../icon/ICON_PLUS'
import { _ } from '../model/ccc'
import { FULL_DATE_LENGTH } from '../model/FULL_DATE_LENGTH'
import { PERSON_DETAILS } from '../model/PERSON_DETAILS'
import { PortraitComp } from './PortraitComp'

export const PageWeddingAnniversariesComp = defineComponent<
	IShowThenProps<any>
>('PageWeddingAnniversariesComp', (props, $) => {
	setPageTitle('Házassági évfordulók')

	const data = getDataOrThrow()

	return (
		<div class={_.ccc_page}>
			<h1>Házassági évfordulók</h1>
			<div class={_.ccc_tiles__centered}>
				<For
					debugName='Házassági évfordulók'
					each={() => {
						const personId__latestMarriageDate = new Map<string, string>()
						const couples = Object.values(data.couplesById).filter(
							(it) =>
								!it.divorcedDate &&
								!it.divorcedPlace &&
								it.marriedDate &&
								it.marriedDate.length === FULL_DATE_LENGTH &&
								it.femaleId &&
								it.maleId &&
								!isDead(data, expectDefined(data.personsById[it.femaleId])) &&
								!isDead(data, expectDefined(data.personsById[it.maleId])),
						)
						for (const couple of couples) {
							for (const personId of [couple.maleId!, couple.femaleId!]) {
								const latest = personId__latestMarriageDate.get(personId)
								personId__latestMarriageDate.set(
									personId,
									latest && latest > couple.marriedDate!
										? latest
										: couple.marriedDate!,
								)
							}
						}
						return couples
							.filter((couple) => {
								for (const personId of [couple.maleId!, couple.femaleId!]) {
									if (
										personId__latestMarriageDate.get(personId) !==
										couple.marriedDate
									) {
										return false
									}
								}
								return true
							})
							.sort((a, b) =>
								(a.marriedDate?.slice(5) ?? '').localeCompare(
									b.marriedDate?.slice(5) ?? '',
								),
							)
					}}
					render={({ get }) => (
						<a
							class={_.ccc_button__person}
							href={() => url`/person/${get().maleId}`}
						>
							<div>
								<Slot get={() => formatDate(get().marriedDate)?.slice(6)} />
								<div class={_.ccc_date}>
									<b>
										<Slot
											get={() =>
												formatNumber(
													getAge(
														get().marriedDate,
														new Date().getFullYear() +
															get().marriedDate!.slice(4),
													),
												)
											}
										/>{' '}
										éves
									</b>{' '}
									lesz
								</div>
							</div>
							<PortraitComp
								getPerson={() => expectDefined(data.personsById[get().maleId!])}
							/>
							<PortraitComp
								getPerson={() =>
									expectDefined(data.personsById[get().femaleId!])
								}
							/>
							<div>
								<Slot
									get={() =>
										getPersonNameFormatted(
											data,
											expectDefined(data.personsById[get().maleId!]),
										)
									}
								/>
								<div>
									<Slot
										get={() =>
											getPersonNameFormatted(
												data,
												expectDefined(data.personsById[get().femaleId!]),
											)
										}
									/>
								</div>
							</div>
						</a>
					)}
				/>
				<a
					class={_.ccc_button__plus}
					href={andrisEmail(
						'Új évforduló',
						`És hiányoltam egy évfordulót:\n\nA férj neve: \n\nA feleség neve: \n\nA házasságkötés ideje: \n\nA házasságkötés helye: \n\nGyerekeik: \n\nA fentiek közül az új személyek adatai:\n\n${indent(PERSON_DETAILS)}`,
					)}
					title='Új évforduló'
				>
					<Icon svg={ICON_PLUS} /> évforduló
				</a>
			</div>
		</div>
	)
})
